import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ClaimType} from 'src/app/shared/models/claim';

@Component({
  selector: 'app-dialog-choose-claim',
  templateUrl: './dialog-choose-claim.component.html',
  styleUrl: './dialog-choose-claim.component.scss'
})
export class DialogChooseClaimComponent {
  claim: ClaimType | undefined = undefined;

  constructor(public dialogRef: MatDialogRef<DialogChooseClaimComponent>,
    @Inject(MAT_DIALOG_DATA)
    public claims: ClaimType[]) {}

  setClaim(e: any) {
    this.claim = e.target.value;
  }

  closeDialog(claim?: ClaimType) {
    this.dialogRef.close(claim);
  }
}
